import enterNumber from './tools/enterNumber'
import focus from './tools/focus'
import preventReClick from './tools/preventReClick'
import permission from './permission'

const install = function (Vue) {
  Vue.directive('enterNumber', enterNumber)
  Vue.directive('focus', focus)
  Vue.directive('reClick', preventReClick)
  Vue.directive('permission', permission)
  Vue.directive('removeAriaHidden', {
    bind(el) {
      const ariaEls = el.querySelectorAll('.el-radio__original')
      ariaEls.forEach((item) => {
        item.removeAttribute('aria-hidden')
      })
    }
  })
  Vue.directive('clickOutside', {
    bind: function (el) {
      let dom = el.querySelector('.el-input__inner')
      dom.addEventListener('blur', function () {
        setTimeout(() => {
          dom.removeAttribute('readonly')
        }, 200)
      })
    }
  })
}

export default install
